<template>
    <div class="main">
        <c-panel title="RELATÓRIO BOLSA FAMÍLIA — FREQUÊNCIA MENSAL" titleIcon="fas fa-hand-holding-heart">
            <div style="color: #909399; font-size: 12px; margin-bottom: 15px;">
                Lista alunos beneficiários do Bolsa Família com matrícula <strong>ATIVA</strong> na instituição, com percentual de frequência calculado no mês selecionado.
            </div>

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                        <el-form-item label="Instituição">
                            <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição" style="width: 100%;">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Mês de referência">
                            <el-date-picker v-model="mes" type="month" format="MM/yyyy" value-format="yyyy-MM" placeholder="Selecione o mês" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" style="padding-top: 24px;">
                        <div class="u-text-right">
                            <el-button @click="imprimirPdf" type="primary" :disabled="!podeGerar">
                                <i class="el-icon-printer"></i> GERAR PDF
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
           
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        mes: '',
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            }
        }
    }),
    computed: {
        instituicaoSelecionada () {
            const inst = this.$store.state.config.instituicao
            return inst && inst.id
        },
        podeGerar () {
            return !!this.mes && !!this.instituicaoSelecionada
        }
    },
    mounted () {
        // Default = mês atual
        const hoje = new Date()
        this.mes = hoje.getFullYear() + '-' + String(hoje.getMonth() + 1).padStart(2, '0')

        // Perfis vinculados a instituição já têm a instituição pré-selecionada no topo do sistema.
        if (this.$store.state.config.instituicao) {
            this.filtro.instituicao = { ...this.$store.state.config.instituicao }
        }
    },
    methods: {
        async changeInstituicao () {
            // Perfis SMED (tipo 4..8) não têm vínculo direto: setam a instituição no config global.
            if (this.$store.state.user.tipo > 3 && this.$store.state.user.tipo <= 8) {
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id)
            }
        },
        imprimirPdf () {
            // Abre no modal padrão de PDF do sistema (event bus 'print' → dialogPrint no layout).
            const i = this.$store.state.config.instituicao.id
            window.eventBus.$emit('print', {
                url: `/api/aluno/relatorio/bolsa-familia/${i}?mes=${this.mes}&formato=pdf`,
                param: null
            })
        },
        gerar (formato) {
            const i = this.$store.state.config.instituicao.id
            window.eventBus.$emit('loading', true)

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/aluno/relatorio/bolsa-familia/${i}?mes=${this.mes}&formato=${formato}`,
                this.$store.getters.getHeaderAuthExcel
            ).then(r => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([r.data], {
                    type: r.headers['content-type'] || (formato === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.download = `bolsa_familia_${this.mes.replace('-', '_')}.${formato === 'pdf' ? 'pdf' : 'xlsx'}`
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
